/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sub-menu[_ngcontent-%COMP%]{padding-top:17px}.sub-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;padding:0;color:#686a6c;font:normal normal normal 14px/16px Roboto;letter-spacing:0;text-decoration:none;width:100%}.sub-menu[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{color:#5587c3;font-weight:500}"];
export { styles as styles };
